export enum PaymentMethod {
  CREDITCARD = 'CREDITCARD',

  IDEAL = 'IDEAL',

  PAYPAL = 'PAYPAL',
}
